import styled, { useTheme } from "styled-components";
import closeMsgImg from "../../asserts/img/closeX.svg";
import Text from "../Text";
import { useMobile } from "../../utils/mobile";

const StyledModal = styled("div")(() => ({
  position: "fixed",
  zIndex: 1102,
  right: 0,
  top: 0,
  left: 0,
  bottom: 0,
  width: "100%",
  height: "100%",
  overflow: "auto",
  display: "none",
  backgroundColor: "rgba(0,85,164, 0.8)",
}));

const ModalContent = styled("div")(({ theme }) => ({
  backgroundColor: theme.color.white,
  opacity: 1,
  margin: "auto",
  padding: 5,
  borderRadius: 7,
  textAlign: "center",
  display: "flex",
  alignItems: " center",
}));

const Modal = ({ children, show, onClose, title, width }) => {
  const theme = useTheme();
  const isMobile = useMobile();

  if (show === false) {
    return null;
  }

  return (
    <StyledModal style={{ display: "flex" }}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: 20,
            width,
          }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1.5rem"
            }}>
            <div>
              {!!title && <Text.H1 color={theme.color.label}>{title}</Text.H1>}
            </div>
            <img
              onClick={() => onClose()}
              alt="closeMsgImg"
              src={closeMsgImg}
              style={{
                width: !!isMobile ? 20 : 14,
                height: !!isMobile ? 20 : 14,
                margin: 0,
                cursor: "pointer",
              }}
            />
          </div>
          <div>{children}</div>
        </div>
      </ModalContent>
    </StyledModal>
  );
};

export default Modal;
